import constants from '../constants';

describe('constants', () => {
  test('it should have proper object properties', () => {
    expect(constants).toHaveProperty('endpoints');
  });
});
